import axios from 'axios'
import store from './../store/store'
export default {
  instance: null,
  getBaseUrl () {
    return store.state.apiHost
  },
  createNew () {
    const baseUrl = this.getBaseUrl()
    const result = axios.create({
      baseURL: baseUrl,
      timeout: 60000,
      // 跨域相关
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Credentials': true,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*'
      }
    })
    // 添加请求拦截器，在请求头中加token
    result.interceptors.request.use(
      config => {
        // if (localStorage.getItem('planNo') !== null) {
        //   config.headers.WorkPlanNo = localStorage.getItem('planNo')
        // } else {
        //   config.headers.WorkPlanNo = ''
        // }
        config.headers.Authorization = store.state.userAuth.userToken
        config.headers.Version = '1.5.1'
        /* https 跨域相关 */
        /* config.strictSSL = false
        config.changeOrigin = true
        config.rejectUnauthorized = true
        config.requestCert = false
        config.agent = false */
        return config
      },
      error => {
        console.log(error)
        return Promise.reject(error)
      }
    )
    result.interceptors.response.use(
      response => {
        const res = {}
        res.status = response.status
        res.data = response.data
        /* const code = response.data ? response.data.code : ''; */
        if (res.status === 401) {
          this.$router.replace({ name: '/' })
          store.commit('updateUserToken', '')
          return Promise.reject(response.data)// 跳转登陆页面
        }
        if (res.status >= 300) {
          return Promise.reject(response.data)// 返回错误状态数据
        }
        return res
        /* return response.data.data; */ // 返回正确状态数据
      },
      error => {
        console.log('axios response error:', error)
        /* if(error.response && error.response.status == 404){
            router.push('/blank.vue')//可做404处理
        } */
        /* return Promise.reject(error) */
        if (error.message === 'Network Error') {
          console.log('请检查您的网络')
        }
        return Promise.reject(error.response)
      }
    )
    this.instance = result
    return this.instance
  },
  update () { // newHost
    // console.log('update hostApi',newHost)
    this.instance = null
    this.instance = this.createNew()
  },
  getInstance () {
    if (this.instance === null) {
      this.instance = this.createNew()
    }
    return this.instance
  }
}



// WEBPACK FOOTER //
// ./src/customJs/axiosApi.js